import React, { createContext, useState, useEffect, useContext } from "react";
import { apiGet, apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import AuthContext from "./AuthContext";
import { isEmpty } from "lodash";
import moment from "moment";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
const BetSlipContext = createContext();

export default BetSlipContext;

export const BetSlipProvider = ({ children }) => {
  const [betLoader, setBetLoader] = useState(false);
  const [unMatchBetAccept, setUnmatchBetaccept] = useState(false);
  const [unMatchedBets, setUnmacthedBets] = useState([]);
  const location = useLocation();
  const {
    user,
    amounutRefresh,
    setMessage,
    message,
    setRightTab,
    profileData,
    rightTab,
  } = useContext(AuthContext);
  const [limit, setLimit] = useState({});
  const [showBetDialog, setShowBetDialog] = useState(false);
  const [showBet, setShowBet] = useState(false);
  const [resetBetPosition, setResetBetPosition] = useState(false);
  const [betPlace, setBetPlace] = useState({
    isPlaced: false,
    message: "",
    betType: "",
  });
  const [betSlipObject, setBetSlipObject] = useState({
    odds: "",
    bidPrice: "",
    teamName: "",
    betType: "",
  });

  useEffect(() => {
    setBetSlipObject({});
  }, [location?.pathname]);

  const handelError = (object, type) => {
    setShowBetDialog(false);
    setBetSlipObject({});
    toast.error(object?.message);
    setBetPlace({
      isPlaced: true,
      betType: type,
      type: "error",
    });
  };

  const resetBetSlipObject = () => {
    setBetSlipObject({
      odds: "",
      bidPrice: "",
      teamName: "",
      betType: "",
    });
  };
  const resetBetPlace = () => {
    setBetPlace({
      isPlaced: false,
      message: "",
      betType: "",
    });
  };

  const resetLayout = () => {
    setBetLoader(false);
    document.getElementById("root").style.pointerEvents = "auto";
  };

  const getCurrentBets = async () => {
    if (!isEmpty(user)) {
      const { status, data: response_users } = await apiGet(
        apiPath.unMatchedBets
      );
      if (status === 200) {
        if (response_users.success) {
          setUnmacthedBets(response_users.results);
        }
      }
    }
  };

  useEffect(() => {
    if (rightTab == "unmatch" && !isEmpty(user)) {
      getCurrentBets();
    }
  }, [rightTab, user]);

  useEffect(() => {
    if (rightTab == "unmatch" && !isEmpty(user)) {
      let interval = setInterval(() => {
        getCurrentBets();
      }, 15000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [rightTab, user]);
  const cancelBet = async (data, id) => {
    const { status, data: response_users } = await apiGet(
      apiPath.cancelUnmatchedBets +
        `?matchBetId=${
          !isEmpty(id)
            ? id
            : data
                ?.map((res) => {
                  return res?.matchBetId;
                })
                .join(",")
        }`
    );
    if (response_users?.success) {
      getCurrentBets();
    }
  };

  const handelPlaceBetFairUpdated = async () => {
    if (!isEmpty(user) && betSlipObject?.bidPrice > 0) {
      setBetLoader(true);
      const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
      let result = {
        eventId: betSlipObject?.eventId,
        marketId: betSlipObject?.marketId,
        betPlaceTime: date,
        betPlaceType: "betfair",
        bet_id: betSlipObject?._id,
        bet: [
          {
            selectionId: betSlipObject?.selectionId,
            teamName: betSlipObject?.teamName || betSlipObject?.runnerName,
            bhav: betSlipObject?.bhav,
            amount: betSlipObject?.bidPrice,
            betType: betSlipObject?.betType,
          },
        ],
      };

      const { status, data: response_users } = await apiPost(
        apiPath.betfairPlaceBetUpdate,
        result
      );
      if (status === 200) {
        if (response_users?.success) {
          getCurrentBets();
          setUnmatchBetaccept(true);
          resetLayout();
          setBetPlace({
            isPlaced: true,
            message: response_users?.message,
            betType: "betFair",
            type: "matched",
          });
          setMessage({
            ...message,
            ...betSlipObject,
            status: true,
            errorType: "P2P",
            message: response_users?.message,
          });
          amounutRefresh();
        } else {
          resetLayout();
          handelError(response_users, "betFair");
        }
      } else {
        resetLayout();
        handelError(response_users, "betFair");
      }
    }
  };

  const handelPlaceBetFair = async (limit, obj) => {
    let newObj = !isEmpty(obj) ? obj : betSlipObject;
    if (profileData?.isOneClickBetStake) {
      setBetLoader(true);
      document.getElementById("root").style.pointerEvents = "none";
    }
    if (!isEmpty(user) && newObj?.bidPrice > 0) {
      setBetLoader(true);
      const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
      let result = {
        eventId: newObj?.object?.eventId,
        marketId: newObj?.newMarketId,
        betPlaceTime: date,
        betPlaceType: "betfair",
        bet: [
          {
            selectionId: newObj?.object?.SelectionId || newObj?.object?.ri,
            teamName: newObj?.teamName || newObj?.object?.runnerName,
            bhav: newObj?.odds,
            amount: newObj?.bidPrice,
            betType: newObj?.betType,
          },
        ],
      };

      const { status, data: response_users } = await apiPost(
        apiPath.betfairPlaceBet,
        result
      );
      if (status === 200) {
        if (response_users?.results?.matchedFlag) {
          setShowBetDialog(false);
          getCurrentBets();
          setResetBetPosition(true);
          resetLayout();
          setBetPlace({
            isPlaced: true,
            message: response_users?.message,
            betType: "betFair",
            type: "matched",
          });
          setRightTab("openBet");
          toast.success("Bet Placed Successfully");
          amounutRefresh();
        } else {
          getCurrentBets();
          resetLayout();
          handelError(response_users, "betFair");
        }
      } else {
        resetLayout();
        handelError(response_users, "betFair");
      }
    }
    if (profileData?.isOneClickBetStake) {
      setBetLoader(false);
      document.getElementById("root").style.pointerEvents = "auto";
    }
  };

  const handelPlaceTie = async () => {
    if (!isEmpty(user) && betSlipObject?.bidPrice > 0) {
      setBetLoader(true);
      const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
      let result = {
        eventId: betSlipObject?.object?.eventId,
        marketId: betSlipObject?.object?.marketId,
        betPlaceTime: date,
        betPlaceType: "tie",
        bet: [
          {
            selectionId: betSlipObject?.object?.SelectionId,
            teamName: betSlipObject?.teamName,
            bhav: betSlipObject?.odds,
            amount: betSlipObject?.bidPrice,
            betType: betSlipObject?.betType,
          },
        ],
      };
      // let isValid = await beforeBetPlace(result);
      // if (isValid?.success) {
      setTimeout(async () => {
        const { status, data: response_users } = await apiPost(
          apiPath.tieBetPlace,
          result
        );
        if (status === 200) {
          if (response_users?.results?.matchedFlag) {
            setShowBetDialog(false);
            setResetBetPosition(true);
            resetLayout();
            setBetPlace({
              isPlaced: true,
              message: response_users?.message,
              betType: "tie",
              type: "matched",
            });
            // setMessage({
            //   ...message,
            //   ...betSlipObject,
            //   status: true,
            //   errorType: "Matched",
            // });
            setRightTab("openBet");
            toast.success("Bet Placed Successfully");
            amounutRefresh();
          } else {
            resetLayout();
            handelError(response_users, "tie");
          }
        } else {
          resetLayout();
          handelError(response_users, "tie");
        }
      }, 2000);
      // } else {
      //   resetLayout();
      //   handelError(isValid, "betFair");
      // }
    }
  };
   const handelPlaceBookmakerWifi = async () => {
    if (!isEmpty(user) && betSlipObject?.bidPrice > 1) {
      const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
      const updatedDate = moment(betSlipObject?.ts).format(
        "YYYY-MM-DD, h:mm:ss",
      );
      setBetLoader(true);
      document.getElementById("root").style.pointerEvents = "none";
      let result = {
        eventId: betSlipObject?.object?.eventId,
        marketId: betSlipObject?.object?.marketId,
        selectionId:
          betSlipObject?.object?.SelectionId ||
          betSlipObject?.object?.selectionID,
        betPlaceTime: date,
        teamName: betSlipObject?.object?.runnerName,
        bhav: betSlipObject?.odds,
        amount: betSlipObject?.bidPrice,
        betType: betSlipObject?.betType,
        betPlaceType: "wifiBookmaker",
        ts: updatedDate,
      };

      setBetLoader(true);
      document.getElementById("root").style.pointerEvents = "none";
      const { status, data: response_users } = await apiPost(
        apiPath.bookmakerBet,
        result,
      );
      if (status === 200) {
        if (response_users?.success) {
          setShowBetDialog(false);
          setResetBetPosition(true);
          resetLayout();
          setBetPlace({
            isPlaced: true,
            message: response_users?.message,
            betType: "bookmaker",
            type: "matched",
          });
          setMessage({
            ...message,
            ...betSlipObject,
            status: true,
            errorType: "Matched",
          }); toast.success("Bet Placed Successfully");
          amounutRefresh();
        } else {
          resetLayout();
          handelError(response_users, "bookmaker");
        }
      } else {
        resetLayout();
        handelError(response_users, "bookmaker");
      }
    }
  };
  const handelPlaceFancy = async (limit, obj) => {
    let newObj = !isEmpty(obj) ? obj : betSlipObject;
    if (profileData?.isOneClickBetStake) {
      setBetLoader(true);
      document.getElementById("root").style.pointerEvents = "none";
      // document.getElementById("loading").style.display = "flex";
    }
    if (!isEmpty(user) && newObj?.bidPrice > 0) {
      setBetLoader(true);
      const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
      const result = {
        eventId: newObj?.object?.eventId,
        marketId: newObj?.object?.marketId,
        centralizedId: newObj?.object?.centralizedId,
        selectionId: newObj?.object?.selectionId,
        betPlaceTime: date,
        fancyName: newObj?.object?.fancyName,
        bhav: newObj?.object?.pt,
        amount: newObj?.bidPrice,
        betType: newObj?.betType,
        betRun: newObj?.object?.rt,
        runnerName: newObj?.object?.fancyName,
        betPlaceType: "fancy",
      };

      let api = apiPath.fancyBetPlace;
      const { status, data: response_users } = await apiPost(api, result);
      if (status === 200) {
        if (response_users?.success) {
          setShowBetDialog(false);
          setResetBetPosition(true);
          resetLayout();
          setBetPlace({
            isPlaced: true,
            message: response_users?.message,
            betType: "fancy",
            type: "matched",
          });
          // setMessage({
          //   ...message,
          //   ...betSlipObject,
          //   status: true,
          //   errorType: "Matched",
          // });
          setRightTab("openBet");
          toast.success("Bet Placed Successfully");
          amounutRefresh();
        } else {
          resetLayout();
          handelError(response_users, "fancy");
        }
      } else {
        resetLayout();
        handelError(response_users, "fancy");
      }
    }
    if (profileData?.isOneClickBetStake) {
      setBetLoader(false);
      document.getElementById("root").style.pointerEvents = "auto";
      // document.getElementById("loading").style.display = "none";
    }
  };

  const handelPlaceSportBook = async () => {
    if (!isEmpty(user) && betSlipObject?.bidPrice > 0) {
      setBetLoader(true);
      const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
      const result = {
        eventId: betSlipObject?.eventId,
        marketId: betSlipObject?.marketId,
        fancySelectionId: betSlipObject?.object?.id,
        selectionId: betSlipObject?.item?.id,
        betPlaceTime: date,
        fancyName: betSlipObject?.item?.marketName,
        bhav: betSlipObject?.odds,
        amount: Number(betSlipObject?.bidPrice),
        betType: "back",
        runnerName: betSlipObject?.object?.selectionName,
        apiSiteSelectionId: betSlipObject?.object?.apiSiteSelectionId,
        betPlaceType: "premiumFancy",
      };
      // let isValid = await beforeBetPlace(result);
      // if (isValid?.success) {
      setTimeout(async () => {
        let api = apiPath.preminumFancyBets;
        const { status, data: response_users } = await apiPost(api, result);
        if (status === 200) {
          if (response_users?.success) {
            setShowBetDialog(false);
            setResetBetPosition(true);
            resetLayout();
            setBetPlace({
              isPlaced: true,
              message: response_users?.message,
              betType: "sportBook",
              type: "matched",
            });
            // setMessage({
            //   ...message,
            //   ...betSlipObject,
            //   status: true,
            //   betType: "back",
            //   errorType: "Matched",
            //   betPlaceType: "sportBook",
            //   teamName: betSlipObject?.item?.marketName,
            // });
            setRightTab("openBet");
            toast.success("Bet Placed Successfully");
            amounutRefresh();
          } else {
            resetLayout();
            handelError(response_users, "sportBook");
          }
        } else {
          resetLayout();
          handelError(response_users, "sportBook");
        }
      }, 2000);
      // } else {
      //   resetLayout();
      //   handelError(isValid, "sportBook");
      // }
    }
  };

  const handelPlaceBookmaker = async (limit, obj) => {
    let newObj = !isEmpty(obj) ? obj : betSlipObject;
    if (profileData?.isOneClickBetStake) {
      setBetLoader(true);
      document.getElementById("root").style.pointerEvents = "none";
    }
    if (!isEmpty(user) && newObj?.bidPrice > 0) {
      setBetLoader(true);
      const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
      let result = {
        eventId: newObj?.object?.eventId,
        marketId: newObj?.object?.marketId,
        selectionId: newObj?.object?.SelectionId,
        betPlaceTime: date,
        teamName: newObj?.teamName || newObj?.object?.runnerName,
        bhav: newObj?.odds,
        amount: newObj?.bidPrice,
        betType: newObj?.betType,
        betPlaceType: "bookmaker",
      };

      const { status, data: response_users } = await apiPost(
        apiPath.bookmakerBet,
        result
      );
      if (status === 200) {
        if (response_users?.success) {
          setShowBetDialog(false);
          setResetBetPosition(true);
          resetLayout();
          setBetPlace({
            isPlaced: true,
            message: response_users?.message,
            betType: "bookmaker",
            type: "matched",
          });
          setRightTab("openBet");
          toast.success("Bet Placed Successfully");
          amounutRefresh();
        } else {
          resetLayout();
          handelError(response_users, "bookmaker");
        }
      } else {
        resetLayout();
        handelError(response_users, "bookmaker");
      }
    }
    if (profileData?.isOneClickBetStake) {
      setBetLoader(false);
      document.getElementById("root").style.pointerEvents = "auto";
    }
  };

  const handelPlaceToss = async () => {
    if (!isEmpty(user) && betSlipObject?.bidPrice > 0) {
      setBetLoader(true);
      const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
      const result = {
        eventId: betSlipObject?.object?.eventId,
        marketId: betSlipObject?.object?.marketId,
        selectionId: betSlipObject?.object?.SelectionId,
        betPlaceTime: date,
        bhav: betSlipObject?.odds,
        amount: betSlipObject?.bidPrice,
        teamName: betSlipObject?.teamName,
      };
      // let isValid = await beforeBetPlace(result);
      // if (isValid?.success) {
      setTimeout(async () => {
        const { status, data: response_users } = await apiPost(
          apiPath.tossBetPlace,
          result
        );
        if (status === 200) {
          if (response_users?.success) {
            setShowBetDialog(false);
            setResetBetPosition(true);
            resetLayout();
            setBetPlace({
              isPlaced: true,
              message: response_users?.message,
              betType: "toss",
              type: "matched",
            });
            setRightTab("openBet");
            // setMessage({
            //   ...message,
            //   ...betSlipObject,
            //   status: true,
            //   errorType: "Matched",
            // });
            toast.success("Bet Placed Successfully");
            amounutRefresh();
          } else {
            resetLayout();
            handelError(response_users, "toss");
          }
        } else {
          resetLayout();
          handelError(response_users, "toss");
        }
      }, 2000);
      // } else {
      //   resetLayout();
      //   handelError(isValid, "toss");
      // }
    }
  };
  let contextData = {
    betLoader,
    showBetDialog,
    setShowBetDialog,
    setBetSlipObject,
    betSlipObject,
    showBet,
    setShowBet,
    resetBetSlipObject,
    resetBetPosition,
    setResetBetPosition,
    handelPlaceBetFair,
    betPlace,
    resetBetPlace,
    setBetPlace,
    handelPlaceFancy,
    handelPlaceSportBook,
    handelPlaceBookmaker,
    setLimit,
    limit,
    setMessage,
    message,
    handelPlaceTie,
    handelPlaceToss,
    handelError,
    setBetLoader,
    resetLayout,
    handelPlaceBetFairUpdated,
    unMatchedBets,
    unMatchBetAccept,
    setUnmatchBetaccept,
    cancelBet,handelPlaceBookmakerWifi
  };
  return (
    <BetSlipContext.Provider value={contextData}>
      {children}
    </BetSlipContext.Provider>
  );
};
